import { defineAgenda } from '@/shared/navigation/core';

/**
 * Agenda seznamu stanic (číselník) — kořenová agenda slicu Products. Univerzální ListPage
 * (engine `@/shared/ui/list-page`, šablona `stationListPage.tsx`). Otevírá detail jako modální vrstvu.
 */
export const stationListAgenda = defineAgenda({
  id: 'app.products.stations',
  path: 'app/products/stations',
  open: {},
  state: {},
  title: 'Stanice',
  icon: 'list',
});
